import { Component, h, Prop, Watch, Host, Method, State } from '@stencil/core';
import { Element } from '@stencil/core/internal';
import _ds from '../../../typescript/dot-stash';

export enum AppLocale {
  "EN" = "en-en",
  "FR" = "fr-fr",
}

@Component({
  tag: 'ds-page',
  styleUrl: 'page.scss',
  shadow: true,
})
export class DSPage {

  CSSClassList: any;

  @Element() container: HTMLDsPageElement;

  @Prop() mods: string | string[] = "";
  @Prop() token: string = "";
  @Prop() locale: AppLocale = AppLocale.FR;
  @Prop() cartUrl: string;

  @State() scrollDisabled = false;

  @Watch('mods')
  modsWatcher( newMods ) {
    this.CSSClassList = _ds.props.toClassList("ds-page", newMods);
  }

  @Method()
  async disableScroll() {
    document.querySelector("body").classList.toggle("modal-open");
    this.scrollDisabled = true;
  }
  
  @Method()
  async enableScroll() {
    document.querySelector("body").classList.toggle("modal-open");
    this.scrollDisabled = false;
  }

  componentWillLoad() {
    this.CSSClassList = _ds.props.toClassList("ds-page", this.mods);
  }

  componentDidLoad() {
    const {location: { hash }} = window;
    if( hash ) {
      const targetElement = document.querySelector(`[name='${hash.substring(1)}']`) as HTMLElement;
      if(targetElement) {
        const scrollY = targetElement.offsetTop - 50;
        window.scroll(0, scrollY);
      }
    }
    this.container.style.opacity = "1";
  }
  
  render() {
    return (
      <Host
        class={{
          ...this.CSSClassList,
          "--scroll-disabled": this.scrollDisabled,
        }}
      >
        <slot />
      </Host>
    );
  }
}